module.exports = __webpack_public_path__ + "images/energy-label-space-a.dfe518.svg";